import { ApiConnectionService } from './../../error-pages/api-connection.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { AppConfig } from '../interfaces/AppConfig';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  static settings: AppConfig;

  constructor(
    private http: HttpClient,
    private apiConnectionService: ApiConnectionService,
    private router: Router
  ) {}

  load(): Promise<void> {
    const jsonFile = '/config.json';
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(jsonFile)
        .pipe(
          tap((response: any) => {
           
            // Set application config
            const baseUrl = response.baseUrl;
            AppConfigService.settings = {
              baseUrl: baseUrl,
              apiUrl: `${baseUrl}api/`,
              dataApiUrl: `${baseUrl}data-api/`,
              recaptchaSiteKey: response.recaptcha,
            };
            
            
          }),
          catchError((err) => {
            console.error("Couldn't load config file", err);
            this.router.navigate(['/error/invalid-config']); // Redirect to invalid config page
            reject("Couldn't load config file");
            return throwError(() => new Error("Couldn't load config file"));
          })
        )
        .subscribe({
          next: () => {
            // After config is set, check API connection
            this.apiConnectionService
              .checkApiConnection()
              .subscribe({
                next: (isConnected) => {
                  if (!isConnected) {
                    // If API connection fails, redirect to 500 page
                    this.router.navigate(['/error/500']);
                  }
                  resolve(); // Resolve after API connection check
                },
                error: (err) => {
                  console.error('Error checking API connection', err);
                  this.router.navigate(['/error/500']);
                  reject('API connection failed');
                },
              });
          },
          error: (err) => {
            console.error('Error loading config file', err);
            this.router.navigate(['/error/invalid-config']); // Redirect to invalid config page
            reject("Couldn't load config file");
          },
        });
    });
  }
}
